import { getPlaceAddress } from '@btime/helpers'
import React from 'react'

import { TO_USER } from '../_constants/assignConstants'
import { useForm, useFormState } from '../../../../packages/kiti/components/form/form/FormHandler'
import { useServiceOrder } from '../_load/ServiceOrderLoader'
import UserSelect from '../../../../containers/users/select/UserSelect'

const UserAssignWrapper = () => {
  const serviceOrder = useServiceOrder()
  const placeAddress = getPlaceAddress(serviceOrder.place)

  const form = useForm()
  const { handleChange } = useFormState()

  if (form.assign !== TO_USER) return false

  return (
    <UserSelect
      value={form.userOrGroup}
      onChange={handleChange('userOrGroup')}
      address={serviceOrder.address || placeAddress}
    />
  )
}

export default UserAssignWrapper
